import React, { useContext } from "react";
import CloseIcon from "../../images/CloseIcon.svg";
import "./DeletePop.css";

export default function PopUp({ approve, reject, atten, setPopUp }) {
  return (
    <>
      <div className="container confirm-popup">
        <div className="confirm-popup-inner ">
          <div className="popUpHeader">
            <div className="popUpDelTitle">Elite Office</div>
            <div className="popUpClose p-0">
              <img
                style={{ cursor: "pointer" }}
                className="popUpCloseIcon"
                src={CloseIcon}
                alt="CloseIcon"
                onClick={() => setPopUp(false)}
              />
            </div>
          </div>

          <div className="confirm-body ps-4 ">
            <div className="row text-start ">
              <div className="delText">
                Are you sure want to {reject}
                {approve}?
              </div>
            </div>
          </div>

          <div className="confirm-footer">
            <div className="row  mt-2 mb-2">
              <div>
                <button
                  type="button"
                  class="btn btn-sm me-2"
                  style={{ background: "#0079bf", color: "white" }}
                  onClick={atten}
                >
                  Okay
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-danger "
                  style={{ color: "white" }}
                  onClick={() => setPopUp(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
